import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgPuzzleIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.261 25.953a2.751 2.751 0 0 1-1.495-.5A5.844 5.844 0 0 1 3.01 23.5 5.867 5.867 0 0 1 2.2 21a2.266 2.266 0 0 1 .978-2.218 1.929 1.929 0 0 1 1.5-.162A4.894 4.894 0 0 1 7.34 21a5.87 5.87 0 0 1 .812 2.5 2.266 2.266 0 0 1-.977 2.218 1.811 1.811 0 0 1-.914.235ZM4.1 20.545Zm-.42-.893Z"
      fill="currentColor"
      data-color="color-2"
    />
    <path
      d="M15 30.434V18.31a3 3 0 0 0-1.5-2.6L3 9.649v7.058a3.861 3.861 0 0 1 1.093-.162 4.237 4.237 0 0 1 1.1.148A6.8 6.8 0 0 1 9.072 20a7.9 7.9 0 0 1 1.077 3.377A4.421 4.421 0 0 1 8.883 26.9Z"
      fill="currentColor"
    />
    <path
      d="M24.825 25.714a2.266 2.266 0 0 1-.977-2.218A5.87 5.87 0 0 1 24.66 21a4.894 4.894 0 0 1 2.67-2.376 1.929 1.929 0 0 1 1.5.162A2.266 2.266 0 0 1 29.8 21a6.331 6.331 0 0 1-2.569 4.448 2.751 2.751 0 0 1-1.5.5 1.811 1.811 0 0 1-.906-.234Zm3.08-5.169Zm.41-.893Z"
      fill="currentColor"
      data-color="color-2"
    />
    <path
      d="M17 30.434V18.31a3 3 0 0 1 1.5-2.6L29 9.649v7.058a3.861 3.861 0 0 0-1.093-.162 4.237 4.237 0 0 0-1.1.148A6.8 6.8 0 0 0 22.928 20a7.9 7.9 0 0 0-1.077 3.377 4.421 4.421 0 0 0 1.266 3.523ZM21.894 4.392C21.387 6.527 19.066 8 16 8s-5.387-1.473-5.894-3.608L4 7.917l10.5 6.063a3 3 0 0 0 3 0L28 7.917Z"
      fill="currentColor"
    />
    <path
      d="M16 6c-2.318 0-4-1.052-4-2.5S13.682 1 16 1s4 1.052 4 2.5S18.318 6 16 6Zm2.017-2.417Z"
      fill="currentColor"
      data-color="color-2"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgPuzzleStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgPuzzleIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const PuzzleIcon: any = SvgPuzzleStyle;
export default PuzzleIcon;
